import { ObsDomain } from "./obs-domain.model";
import { ObsRating } from "./obs-rating.model";

export class ObsForm {
    obsDomains: ObsDomain[];
    obsRatings: ObsRating[];
}